module.exports = __webpack_public_path__ + "img/rho-17-about-m.b581e1db.jpeg";